export function mandatoryEnvironment(value) {
    if (value === "test" || value === "live") {
        return value;
    }
    throw new Error(`Not a valid environment: ${value}`);
}
